import React, { memo } from 'react';

import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { defineMessages, FormattedMessage } from 'react-intl';

import { Box } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { PageHeaderWrapper } from 'src/sections/global/components/page.style';

export const SingleFileModeExplanationInner = styled(PageHeaderWrapper)<{
  position: 'header' | 'footer';
}>(
  {
    color: token('color.text'),
    padding: `${gridSize() * 2}px`,
    display: 'flex',
    alignItems: 'center',
  },
  props =>
    props.position === 'footer' &&
    css({
      'justify-content': 'center',
      'margin-top': `${gridSize() * 2}px`,
    })
);

export const SingleFileModePrHeaderExplanationText = styled.span({
  display: 'inline-block',
  marginLeft: `${gridSize()}px`,
});

const headerMessages = defineMessages({
  largePullRequest: {
    id: 'frontbucket.repository.pullRequest.singleFileModePrHeader.largePullRequest',
    description:
      'Text to display in bold inside the heading of a large pull request.',
    defaultMessage: 'This is a large pull request.',
  },
  largePullRequestExplanation: {
    id: 'frontbucket.repository.pullRequest.singleFileModePrHeader.largePullRequestExplanation',
    description:
      'Explanation text to display in bold inside the heading of a large pull request.',
    defaultMessage:
      'Large pull requests can only be viewed by loading files individually.',
  },
});

const footerMessages = defineMessages({
  description: {
    id: 'frontbucket.repository.pullRequest.singleFileModePrFooter.description',
    description:
      'Text to display below the main pull request area, instructing the user how to navigate between files.',
    defaultMessage:
      'To view another file, use the file tree or navigation buttons in the header.',
  },
});

type SingleFileModeExplanationProps = { position: 'header' | 'footer' };

export const SingleFileModeExplanation = memo(
  ({ position }: SingleFileModeExplanationProps) => {
    return (
      <Box paddingBlock="space.100">
        <SectionMessage>
          {position === 'header' ? (
            <>
              <FormattedMessage
                tagName="strong"
                {...headerMessages.largePullRequest}
              />
              <FormattedMessage
                {...headerMessages.largePullRequestExplanation}
              />
            </>
          ) : (
            <FormattedMessage {...footerMessages.description} />
          )}
        </SectionMessage>
      </Box>
    );
  }
);
